import Vue from "vue";
import Confirm from "./Main.vue";
import router from "@/router/index.js";

// 组件构造器，构造出一个 vue组件实例
const ConfirmConstructor = Vue.extend(Confirm);

function ConfirmOrder(goodsIds, $id, calPriceData, user) {
  const dom = new ConfirmConstructor({
    el: document.createElement("div"),
    router,
    data() {
      return {
        showOrder: false,
        buyBtnLoading: false,
        checked: true,
        orderInfo: {},
        couponInfo: {},
        from_source: 3,
        sub_order_list: [],
        goodsIds: [],
        loading: false,
        calPriceData: {},
      };
    },
  });
  dom.goodsIds = goodsIds;
  dom.showOrder = true;
  dom.calPriceData = calPriceData || {};
  dom.user = user;
  if ($id) {
    document.getElementById($id).appendChild(dom.$el);
  } else {
    document.body.appendChild(dom.$el);
  }
}

// 全局注册
export default () => {
  Vue.prototype.$saasConfirmOrder = ConfirmOrder;
};
